import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';

import { Col, Row } from 'react-flexbox-grid';

import validate from 'validate.js';
import { validateConstraints } from '../../../components/FormWrapper';

import { TextField } from 'redux-form-material-ui';

validate.validators.passwordConfirmation = function(value, options, key, attributes) {
    const { attribute, message } = options;
    if (attributes[attribute] !== null && attributes[attribute] !== '') {
        if (attributes[attribute] !== value) {
            return message;
        }
    }
    return null;
};

const formValidation = values =>
    validateConstraints(values.toJS(), {
        password: {
            presence: true,
            length: {
                minimum: 8,
                message: '^Bitte geben Sie mindestens 8 Zeichen ein.',
            },
        },
        password_confirmation: {
            passwordConfirmation: {
                attribute: 'password',
                message: '^Die beiden Passwörter stimmen nicht überein.',
            },
        },
    });

const AcceptInvitationForm = props => {
    const { handleSubmit, pristine, reset, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Paper zIndex={1}>
                <div>
                    <Row>
                        <Col xs>
                            <p style={{ padding: '10px' }}>
                                Bitte geben Sie mindestens 8 Zeichen ein.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs style={{padding:20}}>
                            <Field
                                name="password"
                                component={TextField}
                                type="password"
                                floatingLabelText="Passwort"
                                label="Password"
                            />
                            <br />
                            <Field
                                name="password_confirmation"
                                component={TextField}
                                type="password"
                                floatingLabelText="Passwort wiederholen"
                                label="Passwort wiederholen"
                            />
                            <br />
                        </Col>
                    </Row>
                </div>
            </Paper>
            <br />
            <Row>
                <Col xs={12}>
                    <Row end="xs">
                        <Col xs={6}>
                            <RaisedButton label="Speichern" primary={true} type="submit" />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </form>
    );
};

export default reduxForm({
    form: 'accept_invitation_form', // a unique identifier for this form
    validate: formValidation,
})(AcceptInvitationForm);
